import APIService from '@/api/DeprecatedAPIService'

/**
 * @deprecated Use api/API.ts.
 */
export default {
  path(id = '') {
    // Use the same path for all queries so that stored data is consistent.
    return `my/user/${id}?_embed=identity,identity.meta`
  },

  patch(id, payload) {
    return APIService.patch(this.path(id), payload)
  },

  get() {
    return APIService.get(this.path())
  },
}
